import { SubmitEvent } from "react";

import { Trans, useTranslation } from "react-i18next";

import { useAuth } from "../../../../../context/Auth/AuthProvider";
import { ENABLE_AUTHENTICATION_STEPS } from "../../../types";
import { BorderFrame } from "../components/BorderFrame";
import { Buttons } from "../components/Buttons";
import { InnerTop } from "../components/InnerTop";

export interface GetEmailCodeProps {
  isLoading: boolean;
  changeStep: (newStep: ENABLE_AUTHENTICATION_STEPS) => void;
  getEmailCodeSubmit: () => void;
}

const GetEmailCode = ({
  isLoading,
  changeStep,
  getEmailCodeSubmit
}: GetEmailCodeProps) => {
  const { user } = useAuth();

  const { t } = useTranslation();

  const handleSecondaryButtonClick = () =>
    changeStep(ENABLE_AUTHENTICATION_STEPS.SelectMethod);

  const handleSubmit = (e: SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    getEmailCodeSubmit();
  };

  return (
    <form onSubmit={handleSubmit} data-testid="get-email-code-form">
      <BorderFrame>
        <InnerTop
          title={
            <Trans
              i18nKey="Security##2FA##get email code##title"
              values={{ email: user?.email }}
              components={{
                1: <span />
              }}
            />
          }
          description={t("Security##2FA##get email code##description")}
        />
      </BorderFrame>

      <Buttons
        isLoadingPrimary={isLoading}
        isPrimaryBtnDisabled={false}
        primaryBtnTitle={t("Button##send code")}
        secondaryBtnTitle={t("Button##back")}
        onSecondaryBtnClick={handleSecondaryButtonClick}
      />
    </form>
  );
};

export { GetEmailCode };
